import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ContentController from '../../apis/controller/content.controller';
import PageTitle from '../../Components/PageTitle';
import Midpart from './Midpart';


function Quote() {
	const [contactUsList, setContactUsList] = useState();
	const [breadCrumbs, setBreadcrumbs] = useState();
    const [loader, setLoader] = useState(false);
    let param = useParams();
    useEffect(() => {
        getContactUsList();
        window.scrollTo(0, 0);
    }, []);

    const getContactUsList = async () => {
        setLoader(true);
        let res = await new ContentController().contactUs();
        if (res && res.status) {
            setContactUsList(res.page);
			setBreadcrumbs(res.breadcrumb);
        }
        setLoader(false);
    };
	return (
		<>
			{breadCrumbs ? <PageTitle title={breadCrumbs.main_title} image={breadCrumbs.image} /> : null}
			<Midpart item={contactUsList} />
		</>
	);
}

export default Quote;

